import type { SVGProps } from "react";
export interface HelmetIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function HelmetIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: HelmetIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M.875 12C.875 5.857 5.856.876 12.001.876c5.766 0 10.505 4.386 11.068 10.005a1.124 1.124 0 1 1-2.238.224 8.877 8.877 0 0 0-17.706.897v3.257l12.756 5.469.17.063a1.876 1.876 0 0 0 2.234-.925l.985-1.932a1.125 1.125 0 1 1 2.004 1.023l-.99 1.939-.003.006a4.125 4.125 0 0 1-5.286 1.894l-12.832-5.5A2.13 2.13 0 0 1 .875 15.34z"
      />
      <path
        fill={color}
        d="m18.125 15.813 2.75 1.682V12l-.001-.048-2.75-.458v4.32Zm-4-2.444 1.75 1.069v-3.32l-1.75-.29v2.54ZM7 12.376a.125.125 0 0 0-.125.124l.01.048a.125.125 0 0 0 .23 0l.01-.048-.01-.048a.13.13 0 0 0-.066-.068zm16.125 5.34c0 1.66-1.817 2.679-3.232 1.814l-7-4.278a2.13 2.13 0 0 1-1.018-1.813v-2.758a2.125 2.125 0 0 1 2.233-2.123l.242.027 7.785 1.297.182.046c.41.14.708.51.752.952q.056.553.056 1.12zm-14-5.216a2.125 2.125 0 0 1-4.24.217l-.01-.217.01-.217A2.127 2.127 0 0 1 7 10.374l.217.012A2.125 2.125 0 0 1 9.125 12.5"
      />
    </svg>
  );
}
